import React from 'react';
import PropTypes from 'prop-types';
import MessageHandler from 'message-handler';
import classnames from 'classnames';

class Notification extends React.PureComponent {
  render() {
    let message = this.props.notification;
    if (this.props.isError) {
      message = MessageHandler.getErrorMessage(this.props.notification);
    }

    const className = classnames(
      'notification',
      {
        'notification-success': !this.props.isError,
        'notification-error': this.props.isError,
      },
    );

    const btnClassName = classnames(
      'btn',
      {
        'btn-success': !this.props.isError,
        'btn-error': this.props.isError,
      },
    );

    const title = this.props.isError ? 'Error!' : 'Success!';

    return (
      <div className={className}>
        <span className="notification-text">
          <b>{title}</b> {message}
        </span>
        <button
          className={btnClassName}
          onClick={this.props.onClick}
        >
          Close
        </button>
      </div>
    );
  }
}

Notification.defaultProps = {
  isError: false,
  notification: '',
};

Notification.propTypes = {
  isError: PropTypes.bool,
  notification: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default Notification;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderResponses/Notification.jsx